import * as _ from "../../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../../wayin-react";
import Panel from "../../panel";
import Layout from "../../../core/layout";
import Toggle from "../../../core/checkbox-like/toggle";
import Header from "../../../core/header";
import { widths, sizes, positions, textAlignments, font } from "../../../../enums";
import { whitelistStyles } from "../../../core/hoc";
import SharingPreview from "./sharing-preview";
import SharingForm from "./sharing-form";
var Sharing = createComponent({
  displayName: 'Sharing',
  propTypes: {
    // public
    isCollapsible: PropTypes.bool,
    isExpanded: PropTypes.bool,
    name: PropTypes.string,
    title: PropTypes.string.isRequired,
    byline: PropTypes.string,
    footer: PropTypes.string,
    network: PropTypes.string.isRequired,
    formConfig: PropTypes.array.isRequired,
    formValues: PropTypes.object,
    onChange: PropTypes.func,
    onToggle: PropTypes.func,
    isStacked: PropTypes.bool,
    assetUploaderConfig: PropTypes.shape({
      prefix: PropTypes.string,
      assetCategories: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
        value: PropTypes.string
      })),
      libraryRef: PropTypes.string,
      containerRef: PropTypes.string
    }),
    // private
    _previewData: PropTypes.object
  },
  defaultProps: {
    isCollapsible: false,
    isExpanded: false,
    name: '',
    byline: '',
    footer: '',
    formValues: {},
    onChange: _.noop,
    onToggle: _.noop,
    isStacked: false,
    assetUploaderConfig: {
      prefix: '',
      assetCategories: [],
      libraryRef: '',
      containerRef: ''
    },
    isDisabled: false,
    // private
    _previewData: {}
  },
  handlers: {
    /**
     * pass up the field name and it's value in an object
     * then pass the same object to the setPreviewData method so it can update local state for the purposes of the preview component
     * will return an object similar to this:
     *
     *  formValues: {
     *    facebookShare: {
     *      caption: 'this is my caption'
     *    }
     *  }
     */
    handleFieldChange: function handleFieldChange(p) {
      return function (e, valueObj) {
        var _formValues;

        var retObj = {
          formValues: (_formValues = {}, _formValues[p.name] = valueObj, _formValues)
        };
        p.onChange(retObj);
        p.setPreviewData(valueObj);
      };
    },

    /**
     * we're going to hand this method the name and checked state of the toggle
     * will return an object similar to this:
     *
     *    facebookShare: {
     *      enabled: true/false
     *    }
     */
    handleToggle: function handleToggle(p) {
      return function (e, toggle) {
        var _p$name, _retObj;

        var retObj = (_retObj = {}, _retObj[p.name] = (_p$name = {}, _p$name[toggle.value] = toggle.checked, _p$name), _retObj); // we're going to surface up an onToggle here so devs are able to distinguish field changes from enabled state changes

        p.onToggle(retObj);
      };
    }
  },
  state: {
    _previewData: {
      value: function value(props) {
        return props.formValues;
      },
      updater: function updater(_updater, p) {
        return {
          setPreviewData: function setPreviewData(fieldValues) {
            return _updater(_.assign({}, p._previewData, fieldValues));
          }
        };
      }
    },
    hasError: {
      value: false,
      updater: function updater(_updater2, p) {
        return {
          // precursor in place for validation options later...
          setHasError: function setHasError(field) {
            return _updater2(false);
          }
        };
      }
    }
  },
  lifecycles: {
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.formValues !== nextProps.formValues) {
        this.props.setPreviewData(nextProps.formValues);
      }
    }
  },
  render: function render(p) {
    return /*#__PURE__*/React.createElement("div", {
      className: "ck sharing",
      style: p.style
    }, /*#__PURE__*/React.createElement(Panel, {
      hasBorder: false,
      padding: {
        horizontal: null,
        vertical: sizes.X1
      }
    }, p.isCollapsible ? /*#__PURE__*/React.createElement(Panel.ExpandableContent, {
      expansionPosition: positions.BOTTOM,
      isExpanded: p.isExpanded,
      expandedTrigger: /*#__PURE__*/React.createElement(Toggle, {
        label: p.title,
        description: p.byline,
        value: "enabled",
        isOn: true,
        onChange: p.handleToggle,
        isDisabled: p.isDisabled
      }),
      isDisabled: p.isDisabled,
      collapsedTrigger: /*#__PURE__*/React.createElement(Toggle, {
        label: p.title,
        description: p.byline,
        value: "enabled",
        isOn: false,
        onChange: p.handleToggle,
        isDisabled: p.isDisabled
      })
    }, /*#__PURE__*/React.createElement(SharingRow, {
      onChange: p.handleFieldChange,
      name: p.name,
      network: p.network,
      formConfig: p.formConfig,
      formValues: p._previewData,
      footer: p.footer,
      isStacked: p.isStacked,
      assetUploaderConfig: p.assetUploaderConfig
    })) : /*#__PURE__*/React.createElement(Panel, {
      hasBorder: false,
      padding: {
        vertical: null,
        horizontal: null
      }
    }, /*#__PURE__*/React.createElement(Header, {
      text: p.title,
      byline: p.byline,
      size: sizes.X4,
      font: {
        family: font.families.SYSTEM,
        weight: font.weights.REGULAR,
        emphasis: font.emphasis.NORMAL
      },
      style: {
        margin: 0
      }
    }), /*#__PURE__*/React.createElement(SharingRow, {
      onChange: p.handleFieldChange,
      name: p.name,
      network: p.network,
      formConfig: p.formConfig,
      formValues: p._previewData,
      footer: p.footer,
      isStacked: p.isStacked,
      assetUploaderConfig: p.assetUploaderConfig
    }))));
  }
});

var SharingRow = function SharingRow(p) {
  return /*#__PURE__*/React.createElement("div", {
    className: "sharing-row"
  }, /*#__PURE__*/React.createElement(Layout, {
    columns: p.isStacked ? widths.ONE : widths.TWO
  }, /*#__PURE__*/React.createElement("div", {
    className: "sharing-form"
  }, /*#__PURE__*/React.createElement(SharingForm, {
    assetUploaderConfig: p.assetUploaderConfig,
    onChange: p.onChange,
    name: p.name,
    network: p.network,
    formConfig: p.formConfig,
    formValues: p.formValues
  })), /*#__PURE__*/React.createElement(Layout.Column, {
    isContentCentered: p.isStacked
  }, /*#__PURE__*/React.createElement("div", {
    className: "sharing-preview"
  }, /*#__PURE__*/React.createElement(SharingPreview, {
    fauxDate: p.fauxDate,
    name: p.name,
    network: p.network,
    previewData: p.formValues
  }))), p.footer ? /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: widths.SIXTEEN,
    textAlign: textAlignments.LEFT
  }, /*#__PURE__*/React.createElement("div", {
    className: "sharing-footer"
  }, /*#__PURE__*/React.createElement(Header, {
    byline: p.footer
  }))) : null));
};

export default whitelistStyles()(Sharing);
//# sourceMappingURL=sharing.js.map